import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingSection = () => (
  <section id="pricing" className="relative py-10 md:py-12"
    style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 40%, #0f2d40 70%, #0f172a 100%)' }}
  >
    {/* Ambient glows */}
    <div className="pointer-events-none absolute -top-20 left-[10%] w-80 h-80 rounded-full opacity-20 blur-3xl"
      style={{ background: 'radial-gradient(circle, rgba(59,130,246,0.6) 0%, transparent 70%)' }} />
    <div className="pointer-events-none absolute -bottom-20 right-[8%] w-72 h-72 rounded-full opacity-15 blur-3xl"
      style={{ background: 'radial-gradient(circle, rgba(16,185,129,0.5) 0%, transparent 70%)' }} />
    <div className="pointer-events-none absolute top-[20%] right-[30%] w-48 h-48 rounded-full opacity-10 blur-2xl"
      style={{ background: 'radial-gradient(circle, rgba(99,102,241,0.6) 0%, transparent 70%)' }} />

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-40px' }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6"
      >
        {/* Left: heading + subtitle */}
        <div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight pb-1"
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #7dd3fc 40%, #34d399 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Simple, Transparent Pricing
          </h2>
          <p className="mt-3 text-base md:text-lg text-slate-400 leading-relaxed">
            Choose the plan that fits your organization
          </p>
        </div>

        {/* Right: See Pricing button */}
        <Link
          to="/pricing"
          className="group inline-flex items-center gap-2 rounded-md bg-blue-500 hover:bg-blue-600 px-7 py-3 text-sm font-bold text-white shadow-sm transition-all duration-200 whitespace-nowrap flex-shrink-0"
        >
          See Pricing
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default PricingSection;
